<template>
  <div>
    <section>
      <div class="container">
        <div class="row my-3">
          <div class="col">
            <h1 class="mt-4">Informations légales</h1>
            <hr />
            <h3>1. Présentation du site.</h3>
            <p class="mb-4">
              En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour
              la confiance dans l'économie numérique, il est précisé aux
              utilisateurs du site
              <a href="http://pvnrealestate.com/">pvnrealestate.com</a>
              l'identité des différents intervenants dans le cadre de sa
              réalisation et de son suivi : <br />
              <br />
              <span class="bis">Propriétaire</span> : Pieter van Naeltwijck –
              Association – 16 Rue Bernard du Bois, 13001 Marseille<br />
              <span class="bis">Créateur</span> :
              <a href="3doublev.com">3doublev</a> <br />
              <span class="bis">Responsable publication</span> : Thérèse BASSE –
              therese.basse@gmail.com Le responsable publication est une
              personne physique ou une personne morale.<br />
              <span class="bis">Webmaster</span> : 3doublev – m.m <br />
              <span class="bis">Hébergeur</span> : scaleway.com – Siège social :
              8 rue de la ville l’Evêque-75008 PARIS <br />
              <span class="bis">Crédits</span> : Michael MIGLIOR <br />
              Le modèle de mentions légales est offert par Subdelirium.com
              <a
                target="_blank"
                href="https://www.subdelirium.com/generateur-de-mentions-legales/"
                >Mentions légales</a
              ><br />
            </p>
            <h3>
              2. Conditions générales d’utilisation du site et des services
              proposés.
            </h3>
            <p class="mb-4">
              L’utilisation du site pvnrealestate.com implique l’acceptation
              pleine et entière des conditions générales d’utilisation ci-après
              décrites. Ces conditions d’utilisation sont susceptibles d’être
              modifiées ou complétées à tout moment, les utilisateurs du site
              pvnrealestate.com sont donc invités à les consulter de manière
              régulière.<br /><br />

              Ce site est normalement accessible à tout moment aux utilisateurs.
              Une interruption pour raison de maintenance technique peut être
              toutefois décidée par Pieter van Naeltwijck, qui s’efforcera alors
              de communiquer préalablement aux utilisateurs les dates et heures
              de l’intervention.<br /><br />

              Le site pvnrealestate.com est mis à jour régulièrement par Thérèse
              BASSE. De la même façon, les mentions légales peuvent être
              modifiées à tout moment : elles s’imposent néanmoins à
              l’utilisateur qui est invité à s’y référer le plus souvent
              possible afin d’en prendre connaissance.<br />
            </p>

            <h3>3. Description des services fournis.</h3>
            <p class="mb-4">
              Le site pvnrealestate.com a pour objet de fournir une information
              concernant l’ensemble des activités de la société.<br /><br />

              Pieter van Naeltwijck s’efforce de fournir sur le site
              pvnrealestate.com des informations aussi précises que possible.
              Toutefois, il ne pourra être tenue responsable des omissions, des
              inexactitudes et des carences dans la mise à jour, qu’elles soient
              de son fait ou du fait des tiers partenaires qui lui fournissent
              ces informations.<br /><br />

              Tous les informations indiquées sur le site pvnrealestate.com sont
              données à titre indicatif, et sont susceptibles d’évoluer. Par
              ailleurs, les renseignements figurant sur le site
              pvnrealestate.com ne sont pas exhaustifs. Ils sont donnés sous
              réserve de modifications ayant été apportées depuis leur mise en
              ligne.<br />
            </p>
            <h3>4. Limitations contractuelles sur les données techniques.</h3>
            <p class="mb-4">
              Le site utilise la technologie JavaScript.<br /><br />

              Le site Internet ne pourra être tenu responsable de dommages
              matériels liés à l’utilisation du site. De plus, l’utilisateur du
              site s’engage à accéder au site en utilisant un matériel récent,
              ne contenant pas de virus et avec un navigateur de dernière
              génération mis-à-jour.<br />
            </p>
            <h4>5. Propriété intellectuelle et contrefaçons.</h4>
            <p class="mb-4">
              Pieter van Naeltwijck est propriétaire des droits de propriété
              intellectuelle ou détient les droits d’usage sur tous les éléments
              accessibles sur le site, notamment les textes, images, graphismes,
              logo, icônes, sons, logiciels.<br /><br />

              Toute reproduction, représentation, modification, publication,
              adaptation de tout ou partie des éléments du site, quel que soit
              le moyen ou le procédé utilisé, est interdite, sauf autorisation
              écrite préalable de : Pieter van Naeltwijck.<br /><br />

              Toute exploitation non autorisée du site ou de l’un quelconque des
              éléments qu’il contient sera considérée comme constitutive d’une
              contrefaçon et poursuivie conformément aux dispositions des
              articles L.335-2 et suivants du Code de Propriété Intellectuelle.
            </p>
            <h4>6. Limitations de responsabilité.</h4>
            <p class="mb-4">
              Pieter van Naeltwijck ne pourra être tenue responsable des
              dommages directs et indirects causés au matériel de l’utilisateur,
              lors de l’accès au site pvnrealestate.com, et résultant soit de
              l’utilisation d’un matériel ne répondant pas aux spécifications
              indiquées au point 4, soit de l’apparition d’un bug ou d’une
              incompatibilité.<br /><br />

              Pieter van Naeltwijck ne pourra également être tenue responsable
              des dommages indirects (tels par exemple qu’une perte de marché ou
              perte d’une chance) consécutifs à l’utilisation du site
              pvnrealestate.com.<br /><br />

              Des espaces interactifs (possibilité de poser des questions dans
              l’espace contact) sont à la disposition des utilisateurs. Pieter
              van Naeltwijck se réserve le droit de supprimer, sans mise en
              demeure préalable, tout contenu déposé dans cet espace qui
              contreviendrait à la législation applicable en France, en
              particulier aux dispositions relatives à la protection des
              données. Le cas échéant, Pieter van Naeltwijck se réserve
              également la possibilité de mettre en cause la responsabilité
              civile et/ou pénale de l’utilisateur, notamment en cas de message
              à caractère raciste, injurieux, diffamant, ou pornographique, quel
              que soit le support utilisé (texte, photographie…).
            </p>
            <h4>7. Gestion des données personnelles.</h4>
            <p class="mb-4">
              En France, les données personnelles sont notamment protégées par
              la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août
              2004, l'article L. 226-13 du Code pénal et la Directive Européenne
              du 24 octobre 1995.<br /><br />

              A l'occasion de l'utilisation du site pvnrealestate.com, peuvent
              êtres recueillies : l'URL des liens par l'intermédiaire desquels
              l'utilisateur a accédé au site pvnrealestate.com, le fournisseur
              d'accès de l'utilisateur, l'adresse de protocole Internet (IP) de
              l'utilisateur.<br /><br />

              En tout état de cause Pieter van Naeltwijck ne collecte des
              informations personnelles relatives à l'utilisateur que pour le
              besoin de certains services proposés par le site
              pvnrealestate.com. L'utilisateur fournit ces informations en toute
              connaissance de cause, notamment lorsqu'il procède par lui-même à
              leur saisie. Il est alors précisé à l'utilisateur du site
              pvnrealestate.com l’obligation ou non de fournir ces
              informations.<br /><br />

              Conformément aux dispositions des articles 38 et suivants de la
              loi 78-17 du 6 janvier 1978 relative à l’informatique, aux
              fichiers et aux libertés, tout utilisateur dispose d’un droit
              d’accès, de rectification et d’opposition aux données personnelles
              le concernant, en effectuant sa demande écrite et signée,
              accompagnée d’une copie du titre d’identité avec signature du
              titulaire de la pièce, en précisant l’adresse à laquelle la
              réponse doit être envoyée.<br /><br />

              Aucune information personnelle de l'utilisateur du site
              pvnrealestate.com n'est publiée à l'insu de l'utilisateur,
              échangée, transférée, cédée ou vendue sur un support quelconque à
              des tiers. Seule l'hypothèse du rachat de Pieter van Naeltwijck et
              de ses droits permettrait la transmission des dites informations à
              l'éventuel acquéreur qui serait à son tour tenu de la même
              obligation de conservation et de modification des données vis à
              vis de l'utilisateur du site pvnrealestate.com.<br /><br />

              Les bases de données sont protégées par les dispositions de la loi
              du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996
              relative à la protection juridique des bases de données.
            </p>
            <h4>8. Liens hypertextes et cookies.</h4>
            <p class="mb-4">
              Le site pvnrealestate.com contient un certain nombre de liens
              hypertextes vers d’autres sites, mis en place avec l’autorisation
              de Pieter van Naeltwijck. Cependant, Pieter van Naeltwijck n’a pas
              la possibilité de vérifier le contenu des sites ainsi visités, et
              n’assumera en conséquence aucune responsabilité de ce fait.<br /><br />

              La navigation sur le site pvnrealestate.com est susceptible de
              provoquer l’installation de cookie(s) sur l’ordinateur de
              l’utilisateur. Un cookie est un fichier de petite taille, qui ne
              permet pas l’identification de l’utilisateur, mais qui enregistre
              des informations relatives à la navigation d’un ordinateur sur un
              site. Les données ainsi obtenues visent à faciliter la navigation
              ultérieure sur le site, et ont également vocation à permettre
              diverses mesures de fréquentation.<br /><br />

              Le refus d’installation d’un cookie peut entraîner l’impossibilité
              d’accéder à certains services. L’utilisateur peut toutefois
              configurer son ordinateur de la manière suivante, pour refuser
              l’installation des cookies :<br /><br />

              Sous Internet Explorer : onglet outil (pictogramme en forme de
              rouage en haut a droite) / options internet. Cliquez sur
              Confidentialité et choisissez Bloquer tous les cookies. Validez
              sur Ok.<br /><br />

              Sous Firefox : en haut de la fenêtre du navigateur, cliquez sur le
              bouton Firefox, puis aller dans l'onglet Options. Cliquer sur
              l'onglet Vie privée. Paramétrez les Règles de conservation sur :
              utiliser les paramètres personnalisés pour l'historique. Enfin
              décochez-la pour désactiver les cookies.<br /><br />

              Sous Safari : Cliquez en haut à droite du navigateur sur le
              pictogramme de menu (symbolisé par un rouage). Sélectionnez
              Paramètres. Cliquez sur Afficher les paramètres avancés. Dans la
              section "Confidentialité", cliquez sur Paramètres de contenu. Dans
              la section "Cookies", vous pouvez bloquer les cookies.<br /><br />

              Sous Chrome : Cliquez en haut à droite du navigateur sur le
              pictogramme de menu (symbolisé par trois lignes horizontales).
              Sélectionnez Paramètres. Cliquez sur Afficher les paramètres
              avancés. Dans la section "Confidentialité", cliquez sur
              préférences. Dans l'onglet "Confidentialité", vous pouvez bloquer
              les cookies.
            </p>
            <h4>9. Droit applicable et attribution de juridiction.</h4>
            <p class="mb-4">
              Tout litige en relation avec l’utilisation du site
              pvnrealestate.com est soumis au droit français. Il est fait
              attribution exclusive de juridiction aux tribunaux compétents de
              Paris.<br />
            </p>
            <h4>10. Les principales lois concernées.</h4>
            <p class="mb-4">
              Loi n° 78-17 du 6 janvier 1978, notamment modifiée par la loi n°
              2004-801 du 6 août 2004 relative à l'informatique, aux fichiers et
              aux libertés.<br /><br />

              Loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie
              numérique.
            </p>
            <h4>11. Lexique.</h4>
            <p class="mb-5">
              Utilisateur : Internaute se connectant, utilisant le site
              susnommé.<br /><br />

              Informations personnelles : « les informations qui permettent,
              sous quelque forme que ce soit, directement ou non,
              l'identification des personnes physiques auxquelles elles
              s'appliquent » (article 4 de la loi n° 78-17 du 6 janvier 1978).
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "account",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
